import { RefObject, useEffect, useRef, useState } from 'react'

interface Intersection {
  observedRef: RefObject<HTMLDivElement | null>
  isIntersecting: boolean
}

export function useIntersection(): Intersection {
  const [isIntersecting, setIntersecting] = useState(false)
  const observedRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!observedRef.current) return

    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting)
    })

    let observerRefCurrent: HTMLDivElement | null = null
    if (observedRef.current) {
      // 監視を開始
      observer.observe(observedRef.current)
      observerRefCurrent = observedRef.current
    }

    if (observerRefCurrent) {
      return () => {
        // 要素の監視を終了する
        observer.unobserve(observerRefCurrent as HTMLDivElement)
      }
    }
  })

  return { observedRef, isIntersecting }
}
